(() => {
  const root = document.querySelector('[data-treedix-product-experience]');
  if (!root) return;

  const dataNode = root.querySelector('[data-pxp-variants-json]');
  const skuRow = root.querySelector('[data-product-sku]');
  const skuValue = skuRow?.querySelector('.treedix-product-sku__value');
  if (!dataNode || !skuRow || !skuValue) return;

  let variants = [];
  try {
    const parsed = JSON.parse(dataNode.textContent || '{}');
    variants = Array.isArray(parsed.variants) ? parsed.variants : [];
  } catch (error) {
    variants = [];
  }

  const selectedOptions = () => Array.from(root.querySelectorAll('[data-pxp-option-group]')).map((group) => {
    const optionIndex = Number.parseInt(group.dataset.optionIndex, 10);
    const active = group.querySelector('[data-pxp-option-value].is-active');
    return [optionIndex, active?.dataset.optionValue];
  }).sort((a, b) => a[0] - b[0]).map((entry) => entry[1]);

  const variantForOptions = () => {
    const options = selectedOptions();
    if (!options.length) return variants[0];
    return variants.find((variant) => Array.isArray(variant.options) && variant.options.every((value, index) => value === options[index]));
  };

  const updateSku = () => {
    const variant = variantForOptions();
    const sku = typeof variant?.sku === 'string' ? variant.sku.trim() : '';
    if (sku) {
      skuValue.textContent = sku;
      skuRow.hidden = false;
    } else {
      skuValue.textContent = '';
      skuRow.hidden = true;
    }
  };

  root.querySelectorAll('[data-pxp-option-value]').forEach((button) => {
    button.addEventListener('click', () => window.setTimeout(updateSku, 0));
  });

  updateSku();
})();
